import { Grid, Box, ButtonBase, Paper, ButtonBaseProps } from "@mui/material";
import { PlayCircleOutline, SvgIconComponent } from "@mui/icons-material";
import { H6, Body3, colorsLight } from "@coherehealth/common";

const DashboardCta = ({ fetchCase }: { fetchCase: () => void }) => {
  return (
    <Grid container>
      <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", width: "100%" }}>
          <CtaButton
            onClick={fetchCase}
            Icon={PlayCircleOutline}
            label="Start next case"
            sublabel="Go to the next most important case for you to work, and get it done!"
            asBlueCard
          />
        </Box>
      </Box>
    </Grid>
  );
};

interface CtaButtonProps extends ButtonBaseProps {
  label: string;
  onClick?: () => void;
  Icon?: SvgIconComponent;
  sublabel?: string;
  asBlueCard?: boolean;
}

const CtaButton = ({ label, onClick, Icon, sublabel, asBlueCard, disabled }: CtaButtonProps) => {
  return (
    <Paper
      sx={{
        display: "flex",
        flexBasis: "64em",
        flexGrow: "1",
        height: "12em",
        borderRadius: "1em",
        backgroundColor: asBlueCard
          ? disabled
            ? colorsLight.gray.dark
            : colorsLight.primary.main
          : disabled
          ? colorsLight.white.disabled
          : undefined,
        "&:hover": !disabled
          ? {
              backgroundColor: asBlueCard ? colorsLight.primary.dark : colorsLight.gray.light,
            }
          : {},
        color: asBlueCard
          ? disabled
            ? colorsLight.white.disabled
            : "white"
          : disabled
          ? colorsLight.gray.dark
          : undefined,
        boxShadow: !disabled
          ? "-0.16px 2.23px 4.63px 0px rgba(41, 92, 113, 0.04), -0.75px 10.17px 13px 0px rgba(41, 92, 113, 0.07), -1.90px 25.75px 34.88px 0px rgba(41, 92, 113, 0.1), -3.75px 50.86px 80px 0px rgba(41, 92, 113, 0.12)"
          : "none",
        border: disabled ? (!asBlueCard ? `1px solid ${colorsLight.gray.divider}` : undefined) : undefined,
      }}
    >
      <ButtonBase
        onClick={onClick}
        sx={{ display: "flex", width: "100%", justifyContent: "flex-start", borderRadius: "1em" }}
        disabled={disabled}
        data-testid="qm-button-start-next-case"
      >
        <Box sx={{ display: "flex", padding: "2em", flexDirection: "column" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {Icon && <Icon sx={{ fontSize: "2.5em", ml: 0.5, mr: 3 }} />}
            <H6 style={{ textAlign: "left" }}>{label}</H6>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", textAlign: "left", mt: 3 }}>
            <Body3>{sublabel}</Body3>
          </Box>
        </Box>
      </ButtonBase>
    </Paper>
  );
};

export default DashboardCta;
